export default __webpack_public_path__ + "static/media/5ZCggE3Tml.a96d09de.gif";